import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { ClothesService } from '../../Services/clothes.service';
import { StockService } from '../../Services/stock.service';

@Component({
  selector: 'app-stock-import',
  template: require('./stock-import.component.html'),
  styles: [require('./stock-import.component.css')]
})
export class StockImportComponent implements OnInit {
  stock:any = [];
  clothes:any=[];
  clothesSizes:any=[];
  stockToImport = [];
  constructor(private stockService: StockService, private clothesService: ClothesService) { }


  ngOnInit() {
    this.refresh();
  }

  refresh(){
    this.loadStock();
    this.loadAllOrderedStockItems();
  }

  loadStock(){
    this.stockService.getStockItems().subscribe( (x:any)=>{
      this.stock = x;
    })
  }

  loadAllOrderedStockItems(){
    this.stockService.getOrderedStockItems().subscribe( (res:any)=>{
      
      if (res.status == 200){
        this.stockToImport = res.value
        // console.log(this.stockToImport);
        
      }
    })
  }

  importStock(){
    var items:any = []
    this.stockToImport.forEach((item:any) => {
      
      var x = { "ItemId": item.id,
                "Amount":item.amount,
                "Size":item.size,
                "CartId": item.cartId,
      }
      items.push(x);     
    });

    var data = {
                "items": items,
              }

    this.stockService.transferCartToStock(data).subscribe ( (res:any) =>{
      this.refresh();
    })

  }

  changeAmount(stockId: number, currentAmount: number){
    console.log("change amount: ");
    var innerhtml = `
        <div style="text-align:left">
          <div class="row mt-4">
          <div class="col col-lg-12">
            <label class="control-label" for="ClothingAmount">Hoeveel zitten er in stock?</label>
          </div>
          <div class="col col-lg-10">
            <input class="form-control" type="number"  min="0" id="ClothingAmount" value="${currentAmount}">
          </div>
        </div>
      </div>
  `
  Swal.fire({
    title: 'Hoeveel items zitten in stock?',
    html: innerhtml,
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Ok',
    cancelButtonText: 'Annuleren',
    preConfirm: function(result){
        if (result){
          var ClothingAmount =  parseInt((<HTMLInputElement>document.getElementById('ClothingAmount')).value as string);
          return {ClothingAmount:ClothingAmount }
        }
      }
    }).then( (result:any) => {
      if (result.value){     
        this.stockService.updateStockAmount(stockId,result.value.ClothingAmount).subscribe( (res:any)=> {
         
          if (res.status == 200){
            this.refresh()
          }
          
        })
      }
    })
  }

  AddSingleItem(){
    this.clothesService.getAllClothes().subscribe( (res:any)=>{
      this.clothes = res;
      if ( this.clothes.length > 0){
         this.loadSizesOfId(this.clothes[0].id)
      }
    })
    
  }

  loadSizesOfId(id: number){
    this.clothesService.getClothesSizesById(id).subscribe ( (res:any) =>{
      this.clothesSizes = res;
    })
    
  }

  AddItemToStock(clothesId:number,size:string, amount: number) {
    this.stockService.addItemToStock(clothesId,size,amount).subscribe ( (res:any)=> {
      if (res.status == 200){
        this.refresh()
      }
    })
  }

  deleteStockItem(stockId: number){
    Swal.fire({
      title: 'Ben je zeker?',
      text: "Ben je zeker dat je dit item wil verwijderen?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Jep',
      cancelButtonText: 'Nope'
    }).then((result) => {
      if (result.value) {
        this.stockService.deleteStockItem(stockId).subscribe( (res:any)=>{
          if (res.status == 200){
            this.refresh();
          }
        })
      }
    });
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/stock-import/stock-import.component.ts